<template>
  <div class="top-menu w-100">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xlg-3 align-self-center text-left" id="socialNetwork">
          <span class="mr-3">Síguenos:</span>
          <a class="facebook" href="https://www.facebook.com/poderjudicialaguascalientes/" target="_blank">
            <i class="fab fa-facebook-f"></i>
          </a>
          <a class="twitter" href="https://www.twitter.com/PJudicialAgs" target="_blank">
            <i class="fab fa-twitter"></i>
          </a>
          <a class="youtube" href="https://www.youtube.com/channel/UCLCGYFc5HenDHHAzBrUq7lw?view_as=subscriber" target="_blank">
            <i class="fab fa-youtube"></i>
          </a>
          <a class="youtube" href="https://www.instagram.com/poderjudicialags/" target="_blank">
            <i class="fab fa-instagram"></i>
          </a>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xlg-9 align-items-center text-right" id="despliegueInformativo">
          <!-- <a v-if="EstaVacioElObjetoOEsError(informeDeLabores) == false" class="mr-3 fuente parpadea" v-on:click="AbrirDocumento(ObtenLaRutaDeDescarga(informeDeLabores.ArchivosDeContenidoDeLaPaginaWeb), '_blank');"><i class="fas fa-envelope-open-text mx-1"></i>&nbsp;{{informeDeLabores.TextoDelContenido}}</a> -->
          <a v-if="EstaVacioElObjetoOEsError(boletinElectronico) == false" class="mr-3 fuente"  v-on:click="AbrirDocumento(ObtenLaRutaDeDescarga(boletinElectronico.ArchivosDeContenidoDeLaPaginaWeb), '_blank');"><i class="fas fa-envelope-open-text mx-1"></i>&nbsp;{{boletinElectronico.TextoDelContenido}}</a>
          <router-link class="inicio-sesion" to="/Login" title="Iniciar sesión en Themis">
            <i class="fas fa-user"></i>
          </router-link>
        </div>        
      </div>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    name: `MenuSuperior`,
    data() {
      return {
        enumeraciones,
        enumeraciones_sicpo,
        PAGINA_WEB_BOLETIN_ELECTRONICO: 29,
        PAGINA_WEB_INFORME_DE_LABORES: 1,
        TIPO_ROL_DE_ARCHIVO: 1,
        boletinElectronico: {},
        cargoBoletinElectronico: Number, 
        informeDeLabores: {},
        cargoInformeDeLabores: Number,
        nombreDeVariableDelComponente: "cargoMenuSuperior"
      }
    },
    mounted() {
      this.cargoBoletinElectronico = this.enumeraciones_sicpo.EstadosDeCarga.Cargando;
      this.cargoInformeDeLabores = this.enumeraciones_sicpo.EstadosDeCarga.Cargando;
      
      this.CargaUnContenidoEspecifico(this.PAGINA_WEB_BOLETIN_ELECTRONICO);
      this.CargaUnContenidoEspecifico(this.PAGINA_WEB_INFORME_DE_LABORES);
    },
    methods: {
      CargaUnContenidoEspecifico: function(paginaWebId) {
        let parametros = {
          EsPrueba: this.enumeraciones.EsPrueba, 
          PaginaWebId: paginaWebId
        }

        axios
          .post(api.conexion + api.SICPO.sistema.paginaweb.paginaoficial.ObtenUnContenidoEspecifico, parametros)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.error(respuesta.data);
              this.LlenaEspecificamenteUnaVariable(null, respuesta.data, paginaWebId, this.enumeraciones_sicpo.EstadosDeCarga.Error);
              this.YaTermineDeCargar();
            } else {
              this.LlenaEspecificamenteUnaVariable(respuesta.data.ContenidoDeLaPaginaWeb, null, paginaWebId, this.enumeraciones_sicpo.EstadosDeCarga.Cargado);
              this.YaTermineDeCargar();
            }
          })
          .catch(excepcion => {
            console.error(excepcion);
            this.LlenaEspecificamenteUnaVariable(null, excepcion, paginaWebId, this.enumeraciones_sicpo.EstadosDeCarga.Error);
            this.YaTermineDeCargar();
          });
      }, 
      LlenaEspecificamenteUnaVariable: function(informacion, error, paginaWebId, estatus) {
        switch(paginaWebId) {
          case this.PAGINA_WEB_BOLETIN_ELECTRONICO:
            this.boletinElectronico = (error != null ? error : informacion);
            this.cargoBoletinElectronico = estatus;
            break;
          case this.PAGINA_WEB_INFORME_DE_LABORES:
            this.informeDeLabores = (error != null ? error : informacion);
            this.cargoInformeDeLabores = estatus;
            break;
        }
      }, 
      EstaVacioElObjetoOEsError: function(objeto) {
        if(objeto === null || objeto === undefined) return true;
        if(Object.keys(objeto).length === 0) return true;
        if(objeto.SiHayError) return true;
        
        return false
      }, 
      ObtenLaRutaDeDescarga: function(archivos) {
        let rutaDeDescarga = "";
//console.log("archivosss_",archivos)
        if(archivos != null && archivos != undefined && archivos.length > 0)
          archivos.forEach(archivo => {
            if(this.TIPO_ROL_DE_ARCHIVO == archivo.TipoRolDeArchivoEnContenido.TipoRolDeArchivoEnContenidoId)
              rutaDeDescarga = archivo.RutaDelArchivo;
          });

        return rutaDeDescarga;
      },
      AbrirDocumento: function(vinculo, formaDeApertura) {
        window.open(vinculo, formaDeApertura);
      },
      YaTermineDeCargar: function() {
        if(this.cargoBoletinElectronico === this.enumeraciones_sicpo.EstadosDeCarga.Error ||
          this.cargoInformeDeLabores === this.enumeraciones_sicpo.EstadosDeCarga.Error) {
          this.$emit("marcaLaCargaYVerifica", this.nombreDeVariableDelComponente, this.enumeraciones_sicpo.EstadosDeCarga.Error);
        } else if(this.cargoBoletinElectronico === this.enumeraciones_sicpo.EstadosDeCarga.Cargado ||
          this.cargoInformeDeLabores === this.enumeraciones_sicpo.EstadosDeCarga.Cargado) {
          this.$emit("marcaLaCargaYVerifica", this.nombreDeVariableDelComponente, this.enumeraciones_sicpo.EstadosDeCarga.Cargado);
        } else {
          this.$emit("marcaLaCargaYVerifica", this.nombreDeVariableDelComponente, this.enumeraciones_sicpo.EstadosDeCarga.Cargando); 
        }
      }
    }
  }
</script>

<style scoped>
.fuente {
  font-weight: 500;
  font-size:70%;
}

.fuente:hover {
  color: #be9a5e;
}

.parpadea {
  animation-name: parpadeo;
  animation-duration: 2s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;

  -webkit-animation-name:parpadeo;
  -webkit-animation-duration: 2s;
  -webkit-animation-timing-function: linear;
  -webkit-animation-iteration-count: infinite;
}

  @-moz-keyframes parpadeo{  
    0% {opacity: 1.0; }
    50% { opacity: 0.3;}
    100% { opacity: 1.0;}
  }

  @-webkit-keyframes parpadeo {  
    0% {opacity: 1.0; }
    50% { opacity: 0.3;}
    100% { opacity: 1.0;}
  }

  @keyframes parpadeo {  
    0% { opacity: 1.0; color: #be9a5e; }
    50% { opacity: 0.3; color: #be9a5e; }
    100% { opacity: 1.0; color: #be9a5e; }
  }

  .top-menu {
    display: flex;
    align-items: center;
    height: auto;
    min-height: 40px;
    font-size: 18px;
    background-color: rgba(0,117,115, .93);
    /*background-color: rgb(34,34,34);*/
    z-index: 10;
    position: relative;
  }

a {
  color: #FFFFFF;
  margin-right: 0px;
}

.facebook:hover {
  color: #3b5998;
}

.twitter:hover {
  color: #00acee;
}

.youtube:hover {
  color: #c4302b;
}

span {
  font-weight: 500;
}

i {
  margin-right: 20px;
}

.inicio-sesion {
  margin-left: 15px;
}

  .inicio-sesion:hover {
    color: #be9a5e;
  }

@media(max-width: 991px) {
  #socialNetwork {
    padding-top: 5px;
    padding-bottom: 5px;
    text-align: center !important;
  }

  #despliegueInformativo {
    padding-bottom: 5px;
    text-align: center !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PaginaOficial/Comun/MenuSuperior/MenuSuperior.vue